/* eslint-disable no-param-reassign */
import produce from 'immer';
import initialState from './initialState';
var cellMetaLoading = produce(function (draft, action) {
  var metaName = action.payload.metaName;
  draft[metaName].loading = true;
}, initialState);
export default cellMetaLoading;